import { useCallback } from 'react';
import OneSignal from 'react-onesignal';
import { strogging } from '@shd/jslib/infra';
import { ONESIGNAL_APP_ID, ONESIGNAL_IS_ACTIVE } from '@constants/keys';

export const useOneSignal = () => {
  const initOneSignal = useCallback(() => {
    // Ensure this code runs only on the client side
    if (typeof window !== 'undefined' && ONESIGNAL_IS_ACTIVE) {
      OneSignal.init({
        appId: `${ONESIGNAL_APP_ID}`,
        // You can add other initialization options here
        notifyButton: {
          enable: true,
        },
        // Uncomment the below line to run on localhost. See: https://documentation.onesignal.com/docs/local-testing
        // allowLocalhostAsSecureOrigin: true,
      });
    }
  }, []);

  const login = (userId: string) => {
    if (ONESIGNAL_IS_ACTIVE) {
      strogging.log('Login to OneSignal');
      OneSignal.login(userId);
    }
  };

  const addEmailAndPhone = (email: string, phone: string) => {
    if (ONESIGNAL_IS_ACTIVE) {
      if (email) {
        strogging.log('Send Email to OneSignal', { email, phone });
        OneSignal.User.addEmail(email);
      }
      if (phone) {
        strogging.log('Send phoneNumber to OneSignal', { email, phone });
        OneSignal.User.addSms(phone);
      }
    }
  };

  const logout = () => {
    if (ONESIGNAL_IS_ACTIVE) {
      strogging.log('Logout from OneSignal');
      OneSignal.logout();
    }
  };

  const oneSignal = {
    initOneSignal,
    login,
    logout,
    addEmailAndPhone,
  };

  return oneSignal;
};
